<template>
  <div class="dot-dropper">
    <div
      class="dot-dropper__bg-wrapper"
      :style="{
        height: height * ratio + 'px',
        width: width * ratio + 'px'
      }"
      @mousemove="updateActiveDotPosition($event)"
      @mouseup="onMouseUp()"
    >
      <img class="dot-dropper__bg" :src="$store.state.assetsPath + backgroundImage" @click="clearStatusDot()">
      <div v-if="statusDot" class="dot-dropper__status">
        x: <input class="form-control" type="number" v-model.number="statusDot.x"> y: <input class="form-control" type="number" v-model.number="statusDot.y">
      </div>
      <div
        v-for="element in value"
        v-if="elementIds.includes(element._id)"
        :key="element._id"
        class="dot-dropper__dot"
        @mousedown="onMouseDown(element)"
        @mouseup="onMouseUp()"
        :style="{
          left: element[markerAttribute].x * ratio + 'px',
          top: element[markerAttribute].y * ratio + 'px'
        }"
      >
        <div class="dot-dropper__dot-label">
          <div>{{ element.label }}</div>
          <div class="text-black-50">x: {{ element[markerAttribute].x.toFixed(0) }} y: {{ element[markerAttribute].y.toFixed(0) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { throttle } from 'lodash'
export default {
  props: {
    elementIds: Array,
    width: Number,
    height: Number,
    backgroundImage: String,
    value: Array,
    markerAttribute: {
      type: String,
      default: 'marker'
    }
  },

  data () {
    return {
      activeDot: null,
      statusDot: null,
      ratio: null
    }
  },
  

  methods: {
    clearStatusDot () {
      this.statusDot = null
    },

    updateRatio () {
      this.ratio = this.$el.offsetWidth / this.width
    },

    updateActiveDotPosition (e) {
      if (this.activeDot) {
        this.activeDot.x = Math.round(this.activeDot.x + e.movementX / this.ratio)
        this.activeDot.y = Math.round(this.activeDot.y + e.movementY / this.ratio)
        // this.activeDot.x += parseInt((e.movementX / this.ratio).toFixed(0))
        // this.activeDot.y += parseInt((e.movementY / this.ratio).toFixed(0))
      }
    },

    onMouseDown (element) {
      this.activeDot = element[this.markerAttribute]
      this.statusDot = element[this.markerAttribute]
    },
    
    onMouseUp () {
      this.activeDot = null
      this.$emit('input', this.value)
    },    
  },

  mounted () {
    window.addEventListener('resize', throttle(e => {
      this.updateRatio()
    }, 100))
    this.updateRatio()
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";

.dot-dropper {
  max-width: 3040px;

  &__bg-wrapper {
    border: 1px solid #d4d4d4;
    position: relative;
    user-select: none;
  }

  &__bg {
    // pointer-events: none;
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &__status {
    background-color: rgba($white, 0.7);
    color: $black;
    padding: 10px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    input.form-control  {
      display: inline-block;
      padding: 0 5px;
      width: 60px;
    }
  }

  &__dot {
    border-radius: 5px;
    background-color: red;
    cursor: pointer;
    position: absolute;
    height: 11px;
    width: 11px;
    user-select: none;
    transform: translate(-50%, -50%);
    opacity: 1;
    
    &::before {
      position: absolute;
      content: "";
      left: 5px;
      top: 0;
      background-color: #fff;
      height: 11px;
      width: 1px;
    }

    &::after {
      position: absolute;
      content: "";
      left: 0;
      top: 5px;
      background-color: #fff;
      height: 1px;
      width: 11px;
    }

    &:hover {
      .dot-dropper__dot-label {
        opacity: 1;
      }
    }
  }

  &__dot-label {
    bottom: calc(100% + 10px);
    background-color: white;
    border-radius: 2px;
    font-size: 12px;
    opacity: 0;
    padding: 5px 10px;
    pointer-events: none;
    position: absolute;
    text-align: center;
    white-space: nowrap;
    z-index: 999;

    &:after {
      content: "";
      left: 0;
      position: absolute;
      top: 100%;
      border: 5px solid white;
      border-color: white transparent transparent;
    }
  }
}
</style>
